export const getSubdomain = () => {
  const hostname = window.location.hostname;
  const splittedHostname = hostname.split('.');

  return splittedHostname[0] === 'www' ? splittedHostname[1] : splittedHostname[0]
}